import React from "react";
import { CalendarClock } from "lucide-react";

/**
 * HeroStrategyCTA — Prominent "Book a Strategy Call" button rendered
 * inside the existing hero CTA row. Deep obsidian background, Liquid
 * Gold accent, opens Calendly in a new tab.
 */
const CALENDLY_URL = "https://calendly.com/empowerinvestgrow/30min";
const GOLD = "#C9A84C";

export default function HeroStrategyCTA() {
    return (
        <div className="flex flex-col items-start gap-2" data-testid="hero-strategy-cta-wrap">
            <a
                href={CALENDLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-strategy-cta"
                className="group inline-flex items-center gap-2 px-7 py-3.5 font-bold uppercase tracking-[0.22em] text-sm transition-all duration-300"
                style={{
                    fontFamily: "'Montserrat', sans-serif",
                    background: GOLD,
                    color: "#050A0F",
                    border: `1px solid ${GOLD}`,
                    boxShadow: `0 0 22px rgba(201,168,76,0.28)`,
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "0 0 34px rgba(201,168,76,0.55)";
                    e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "0 0 22px rgba(201,168,76,0.28)";
                    e.currentTarget.style.transform = "translateY(0)";
                }}
            >
                <CalendarClock size={16} />
                Book a Strategy Call
            </a>
            <span
                className="text-[11px] text-muted-foreground pl-1"
                data-testid="hero-strategy-cta-sub"
                style={{ fontFamily: "'Inter', 'Montserrat', sans-serif" }}
            >
                30-minute complimentary infrastructure review
            </span>
        </div>
    );
}
